export type Props = { text: string };

export function BarDescription({ text }: Props) {
	return <span class="text-sm text-dark-blue-50">{text}</span>;
}
